import React, { useState } from 'react';
import Select from 'src/components/Select';
import JobsList from './JobsList';

import style from './Jobs.module.scss';

function Jobs({ positions, lang }) {
  const [jobsList, setJobsList] = useState(positions);
  const [department, setDepartment] = useState('');
  const defaultDepartment = 'All Positions';

  const [departments] = useState(() => {
    if (!positions.length) return [];

    return Array.from(
      new Set([...positions.map((job) => job.department.name || 'Other')])
    );
  });

  function changeDepartment(newDepartment) {
    const { value } = newDepartment.target;

    setDepartment(value);
    setJobsList(filterJobs(value));
  }

  function filterJobs(filterDepartment) {
    return positions.filter((job) => {
      if (filterDepartment === '') {
        return true;
      }

      return (
        job.department.name === filterDepartment ||
        (job.department.name == null && filterDepartment === 'Other')
      );
    });
  }

  return (
    <div className={`container ${style.positions}`}>
      <div className={style.header}>
        {departments.length > 1 && (
          <Select
            onChange={changeDepartment}
            selectedValue={department}
            defaultValue={defaultDepartment}
            options={departments}
            className={style['department-select']}
          />
        )}
      </div>
      <div className="row">
        <JobsList jobsList={jobsList} lang={lang} className="col-12" />
      </div>
    </div>
  );
}

export default Jobs;
